// JavaScript code for acf_blocks/pitch-calculator component
(($) => {

    "use strict";
    if ($(".acf-blocks-pitch-calculator").length === 0) {
        return;
    }

    console.log("acf_blocks/pitch-calculator scripts loaded...");

    $(document).ready(() => calculate());
    $("input", ".acf-blocks-pitch-calculator").on("input", () => validateFields());
    $("input", ".acf-blocks-pitch-calculator").on("change", () => calculate());

    function resetFieldsCssState() {
        $(".input-field", ".acf-blocks-pitch-calculator").css("border-color", "");
        $(".error-msg", ".acf-blocks-pitch-calculator").removeClass("active");
    }

    function validateFields() {
        let averageDealSize = parseInt($("#average_deal_size").val().replaceAll(',', '')) || 0;
        let numberOfPitchesPerYear = parseInt($("#number_of_pitches_per_year").val()) || 0;
        let currentPitchWinRate = parseInt($("#current_pitch_win_rate").val()) || 0;
        let approxNumberOfPeopleToTrain = parseInt($("#approx_number_of_people_to_train").val()) || 0;
        let expectedWinRatePostTraining = parseInt($("#expected_win_rate_post_training").val()) || 0;
        resetFieldsCssState();

        if (averageDealSize <= 0) {
            $("#average_deal_size").siblings(".error-msg").addClass("active");
            $("#average_deal_size").parent('.input-field').css("border-color", "red");
        }
        if (numberOfPitchesPerYear <= 0) {
            $("#number_of_pitches_per_year").siblings(".error-msg").addClass("active");
            $("#number_of_pitches_per_year").parent('.input-field').css("border-color", "red");
        }
        if ($("#current_pitch_win_rate").val() === "" || currentPitchWinRate < 0 || currentPitchWinRate > 100) {
            $("#current_pitch_win_rate").siblings(".error-msg").addClass("active");
            $("#current_pitch_win_rate").parent('.input-field').css("border-color", "red");
        }
        if (approxNumberOfPeopleToTrain <= 0) {
            $("#approx_number_of_people_to_train").siblings(".error-msg").addClass("active");
            $("#approx_number_of_people_to_train").parent('.input-field').css("border-color", "red");
        }
        if ($("#expected_win_rate_post_training").val() === "" || expectedWinRatePostTraining < 0 || expectedWinRatePostTraining > 100) {
            $("#expected_win_rate_post_training").siblings(".error-msg").addClass("active");
            $("#expected_win_rate_post_training").parent('.input-field').css("border-color", "red");
        }

        return {
            averageDealSize,
            numberOfPitchesPerYear,
            currentPitchWinRate,
            approxNumberOfPeopleToTrain,
            expectedWinRatePostTraining
        }
    }

    function calculate() {
        let {
            averageDealSize,
            numberOfPitchesPerYear,
            currentPitchWinRate,
            approxNumberOfPeopleToTrain,
            expectedWinRatePostTraining
        } = validateFields();

        if (averageDealSize <= 0) {
            averageDealSize = pitchCalculatorDefaultValues.averageDealSize;
            $("#average_deal_size").val(averageDealSize);
        }
        if (numberOfPitchesPerYear <= 0) {
            numberOfPitchesPerYear = pitchCalculatorDefaultValues.numberOfPitchesPerYear;
            $("#number_of_pitches_per_year").val(numberOfPitchesPerYear);
        }
        if (currentPitchWinRate < 0 || currentPitchWinRate > 100) {
            currentPitchWinRate = pitchCalculatorDefaultValues.currentPitchWinRate;
            $("#current_pitch_win_rate").val(currentPitchWinRate);
        } else if (currentPitchWinRate == 0) {
            $("#current_pitch_win_rate").val(0);
        }
        if (approxNumberOfPeopleToTrain <= 0) {
            approxNumberOfPeopleToTrain = pitchCalculatorDefaultValues.approxNumberOfPeopleToTrain;
            $("#approx_number_of_people_to_train").val(approxNumberOfPeopleToTrain);
        }
        if (expectedWinRatePostTraining < 0 || expectedWinRatePostTraining > 100) {
            expectedWinRatePostTraining = pitchCalculatorDefaultValues.expectedWinRatePostTraining;
            $("#expected_win_rate_post_training").val(expectedWinRatePostTraining);
        } else if (expectedWinRatePostTraining == 0) {
            $("#expected_win_rate_post_training").val(0);
        }

        let additionalRevenue = (numberOfPitchesPerYear * averageDealSize * (expectedWinRatePostTraining / 100)) - (numberOfPitchesPerYear * averageDealSize * (currentPitchWinRate / 100));
        let estimatedCostOfTraining = approxNumberOfPeopleToTrain * pitchCalculatorDefaultValues.investmentPerPerson;
        let roi = ((additionalRevenue - estimatedCostOfTraining) / estimatedCostOfTraining) * 100;

        $(".additional-revenue .result", ".acf-blocks-pitch-calculator").text(additionalRevenue.toLocaleString('en-AU', {
            style: 'currency',
            currency: 'AUD',
            maximumFractionDigits: 0
        }));
        $(".estimated-roi .result", ".acf-blocks-pitch-calculator").text(Math.round(roi) + "%");
        resetFieldsCssState();
    }

})(jQuery);